import { useEffect, useState } from "react";
import { constants, socketMsgType } from "../../common/constants";
import withUser from "../../redux/HOC/withUser";
import { getContractActivity } from "../../utils/API";
import "./style.css";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Label } from "reactstrap";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TextField } from "@mui/material";
import moment from "moment";
import SearchIcon from "@mui/icons-material/Search";
import SockJS from "sockjs-client";
import { Stomp } from "@stomp/stompjs";
import { debounceGlobalSearch, getTimeStamp } from "../../common/commonFunctions";
import _ from "lodash";
import { BASE_URI_SOCKET, envs, getEnv } from "../../config/service-api-mapping";
import ContractActivityGrid from "./Grid";
import { useNavigate } from "react-router";

interface ContractActivityProps {
  contractId: any;
  contractType: any;
  user: any;
}

const ContractActivity = ({
  contractId,
  contractType,
  user,
}: ContractActivityProps) => {
  const heightAG_1 = 30;
  const [refData, setRefData] = useState<any>(null);
  const [gridApiSec, setGridApiSec] = useState<any>(null);
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);
  const [totalRows, setTotalRows] = useState<any[]>([]);
  const [filteredRows, setFilteredRows] = useState<any>([]);
  const [globalSearch, setGlobalSearch] = useState<string>("");
  const [isValidDateRange, setIsValidDateRange] = useState<boolean>(true);
  const [insertActivityRow, setInsertActivityRow] = useState<any>([]);
  const socketConsolidate = new SockJS(`${BASE_URI_SOCKET()}`);
  const socketConsolidateClient = Stomp.over(function () {
    return socketConsolidate;
  });

  const navigate = useNavigate();

  const onStartDateChange = (date: any) => {
    setStartDate(date);
  };

  const onEndDateChange = (date: any) => {
    setEndDate(date);
  };

  useEffect(() => {
      socketConsolidateClient.connect(
        {},
        function (frame: any) {
          socketConsolidateClient.subscribe(
            "/topic/consolidated_message",
            function (result: any) {
              let resultJson = JSON.parse(result?.body);
              if(getEnv() !== envs.PROD){
                console.log(`Data received from /topic/consolidated_message at ${moment()?.toDate()} - `, resultJson);
              }
              onSocketMsgReceive(resultJson?.socketMssgmap);
            }
          );
        },
        {},
        () => {}
      );
    
    return () => {
      if (socketConsolidateClient?.connected) {
        socketConsolidateClient?.unsubscribe("/topic/consolidated_message");
        socketConsolidateClient?.disconnect();
      }
    };
  }, []);

  const onSocketMsgReceive = (msg:any)=>{
    const contractActList = _.get(msg, socketMsgType.CONTRACT_ACTIVITY);
    if (_.isArray(contractActList) && !_.isEmpty(contractActList)) {
      let socketRows = [...contractActList]?.map((item: any) => {
        let con = item?.messageJson;
          return {
            ...con,
            id: con?.activity_id,
            cptyName : con?.cpty_name,
            bl : con?.contract_type,
            secid : con?.cusip,
            colValue : con?.contract_value,
            coll_type : con?.collatoral_code,
            cptyId : con?.cpty_id,
            updatedDateStr : getTimeStamp(
              con?.update_date
            ),
            updatedDate : new Date(con.update_date),
            createdDate : getTimeStamp(con.create_date),
            user_id:con?.trader
          };
      });
      const filteredRows = socketRows?.filter((c:any)=> c?.ui_status !== 'Failed' && contractId === c?.contract_id && contractType === c?.contract_type)
      if(filteredRows && filteredRows?.length>0){
        setInsertActivityRow(filteredRows)
      }
    }
  }

  const insertFilteredRows = (row: any[]) => {
    setFilteredRows((previousRows: any) => {
      if (_.isArray(previousRows)) {
        const mergedRows = [...row, ...previousRows]
        const uniqueRows = _.unionBy(mergedRows, 'activity_id');
        return uniqueRows;
      }
      return previousRows;
    });
  };

  useEffect(() => {
    if (insertActivityRow && insertActivityRow?.length>0) {
      let startingDate = moment(startDate).format("yyyy-MM-DD");
      let endingDate = moment(endDate).format("yyyy-MM-DD");
      if(startDate || endDate){
        setTotalRows((previousRows: any) => {
          if (
            !_.isNull(startDate) ||
            !_.isNull(endDate)
            
          ) {
            const filteredRange = insertActivityRow?.filter((row:any)=> (
              row.update_date &&
              moment(moment(row.update_date).format("yyyy-MM-DD")).isSameOrAfter(
                startingDate
              ) &&
              moment(moment(row.update_date).format("yyyy-MM-DD")).isSameOrBefore(
                endingDate
              )
            ))
            if(filteredRange && _.isArray(filteredRange) && filteredRange?.length>0)
            insertFilteredRows(filteredRange);
          }
          return [...insertActivityRow, ...previousRows];
        });
      }
      else{
        setTotalRows((previousRows: any) => {
          insertFilteredRows(insertActivityRow);
          const mergedRows = [...insertActivityRow, ...previousRows]
          const uniqueRows = _.unionBy(mergedRows, 'activity_id');
          
          return uniqueRows;
        });

      }
      
    }
  }, [insertActivityRow]);

  useEffect(() => {
    let isValid = true;
    if (
      startDate &&
      moment.isDate(startDate) &&
      endDate &&
      moment.isDate(endDate)
    ) {
      isValid = moment(startDate).isSameOrBefore(endDate, "day");
      setIsValidDateRange(isValid);
      if (isValid) {
        applyDateRangeFilter();
      }
    } else if (startDate && moment.isDate(startDate)) {
      setIsValidDateRange(isValid);
      applyStartDateFilter();
    } else if (endDate && moment.isDate(endDate)) {
      setIsValidDateRange(isValid);
      applyEndDateFilter();
    } else if (!startDate && !endDate) {
      //let mappedFilteredRows = mapRowId(totalRows);
      setFilteredRows(totalRows);
    }
  }, [startDate, endDate]);

  const applyStartDateFilter = () => {
    let startingDate = moment(startDate).format("yyyy-MM-DD");
    let currentTotalRows = [...totalRows];
    let rows = currentTotalRows.filter(
      (t: any) =>
        t.update_date &&
        moment(moment(t.update_date).format("yyyy-MM-DD")).isSameOrAfter(
          startingDate
        )
    );
    //let mappedFilteredRows = mapRowId(rows);
    setFilteredRows(rows);
  };

  const applyEndDateFilter = () => {
    let endingDate = moment(endDate).format("yyyy-MM-DD");
    let currentTotalRows = [...totalRows];
    let rows = currentTotalRows.filter(
      (t: any) =>
        t.update_date &&
        moment(moment(t.update_date).format("yyyy-MM-DD")).isSameOrBefore(
          endingDate
        )
    );
    //let mappedFilteredRows = mapRowId(rows);
    setFilteredRows(rows);
  };

  const isRowWithinDateRange = (row: any) => {
    let startingDate = moment(startDate).format("yyyy-MM-DD");
    let endingDate = moment(endDate).format("yyyy-MM-DD");
    
    return (
      row.update_date &&
      moment(moment(row.update_date).format("yyyy-MM-DD")).isSameOrAfter(
        startingDate
      ) &&
      moment(moment(row.update_date).format("yyyy-MM-DD")).isSameOrBefore(
        endingDate
      )
    );
  };

  const applyDateRangeFilter = () => {
    if (startDate && endDate) {
      let startingDate = moment(startDate).format("yyyy-MM-DD");
      let endingDate = moment(endDate).format("yyyy-MM-DD");
      let currentTotalRows = [...totalRows];
      let rows = currentTotalRows.filter(
        (t: any) =>
          t.update_date &&
          moment(moment(t.update_date).format("yyyy-MM-DD")).isSameOrAfter(
            startingDate
          ) &&
          moment(moment(t.update_date).format("yyyy-MM-DD")).isSameOrBefore(
            endingDate
          )
      );
      //let mappedFilteredRows = mapRowId(rows);
      setFilteredRows(rows);
    }
  };

  const onSearch = (event: any) => {
    debounceGlobalSearch(event.target.value, setGlobalSearch);
  };

  useEffect(() => {
    if (contractId && contractType) initializeGrid();
  }, [contractId, contractType]);

  const initializeGrid = async () => {
    setStartDate(null);
    setEndDate(null);
    let request = {
      contractId: contractId,
      bl: contractType,
    };
    var accessToken = window.localStorage.getItem("refreshtoken");
    let contractActivity: any = await getContractActivity(
      request,
      user.tokenType,
      accessToken
    );
    if (contractActivity?.status === 200) {
      let responseJson = await contractActivity.json();
      let rows = responseJson.map((r: any) => ({
        ...r,
        updatedDateStr: getTimeStamp(
          r?.update_date
        ),
        updatedDate: new Date(r.update_date),
        createdDate: getTimeStamp(r.create_date),
        id: r?.activity_id?.toString()
      }));
      let sortedRows = _.orderBy(rows, ["updatedDate"], ["desc"]);
      setFilteredRows([...sortedRows]);
      setTotalRows([...sortedRows]);
    } else if (contractActivity.status === 401) {
      navigate("/signin");
    }
  };

  return (
    <>
      <div className="d-flex">
        <div className="me-auto mt-1 global-search">
          <input
            type="search"
            placeholder="Global search..."
            id="filter-text-box-sec"
            onInput={onSearch}
          />
          <SearchIcon style={{ fontSize: "1rem", color: "#1e355e" }} />
        </div>
        <div className="mb-2">
          <Label className="me-2 mt-1 date-label">Start Date:</Label>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              openTo="day"
              views={["year", "month", "day"]}
              value={startDate}
              inputFormat="mm/dd/yyyy"
              InputProps={{
                notched: false,
                style: { fontSize: 13, color: "#212529" },
              }}
              onChange={(date) => {
                onStartDateChange(date);
              }}
              renderInput={(params) => (
                <TextField
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-input": {
                      height: "0.4rem",
                      width: "4.4rem",
                      border: "none",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                  }}
                  style={{
                    border: "1px solid #eaecef",
                    fontSize: "0.8rem",
                    color: "#212529",
                  }}
                  {...params}
                />
              )}
            />
          </LocalizationProvider>
          <Label className="mx-2 date-label">End Date:</Label>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              openTo="day"
              views={["year", "month", "day"]}
              value={endDate}
              inputFormat="mm/dd/yyyy"
              InputProps={{
                notched: false,
                style: { fontSize: 13, color: "#212529" },
              }}
              onChange={(date) => {
                onEndDateChange(date);
              }}
              renderInput={(params) => (
                <TextField
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-input": {
                      height: "0.4rem",
                      width: "4.4rem",
                      border: "none",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                  }}
                  style={{
                    border: "1px solid #eaecef",
                    fontSize: "0.8rem",
                    color: "#212529",
                  }}
                  {...params}
                />
              )}
            />
          </LocalizationProvider>
        </div>
      </div>
      {!isValidDateRange && (
        <div className="error-style d-flex justify-content-end w-100 mb-2">
          End Date should not be less than Start Date
        </div>
      )}
      <ContractActivityGrid
        rowData={filteredRows}
        insertRowId={insertActivityRow ? insertActivityRow.id : null}
        height={heightAG_1}
        type={constants.ContractActivity}
        globalSearch={globalSearch}
        getBtnRef={(gridRef: any) => {
          setRefData(gridRef);
        }}
        getGridApi={(gridApi: any) => {
          setGridApiSec(gridApi);
        }}
      />
    </>
  );
};
export default withUser(ContractActivity);
